import { render } from "./JournalDetailsPage.vue?vue&type=template&id=d2b2f042"
import script from "./JournalDetailsPage.vue?vue&type=script&lang=js"
export * from "./JournalDetailsPage.vue?vue&type=script&lang=js"

import "./JournalDetailsPage.vue?vue&type=style&index=0&id=d2b2f042&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__